export const propMapping = {
  'userdata.addressinfo.street': 'getUserInput.street',
  'userdata.addressinfo.streetnumber': 'getUserInput.housenumber',
  'userdata.user.user.user_housenumber': 'getUserInput.housenumber',
  'userdata.user.user.user_housenumber_addition':
    'getUserInput.housenumberaddition',
  'userdata.user.user.user_zipcode': 'getUserInput.postcode',
  'form.housenumberaddition': 'getUserInput.housenumberaddition',
  'userdata.addressinfo.nl_sixpp': 'getUserInput.postcode',
  'userdata.addressinfo.city': 'getUserInput.city',
  'userdata_3p.addressinfo.street': 'startWidget.street',
  'userdata_3p.addressinfo.streetnumber': 'startWidget.housenumber',
  'userdata_3p.user.user.user_housenumber': 'startWidget.housenumber',
  'userdata_3p.user.user.user_housenumber_addition':
    'startWidget.housenumberaddition',
  'userdata_3p.user.user.user_zipcode': 'startWidget.postcode',
  'form_3p.housenumberaddition': 'startWidget.housenumberaddition',
  'userdata_3p.addressinfo.nl_sixpp': 'startWidget.postcode',
  'userdata_3p.addressinfo.city': 'startWidget.city',
  'product.provider.name': 'overview.selectedProduct.provider.name',
  'product.provider.attributes.insurancecard_bc':
    'overview.selectedProduct.provider.attributes.insurancecard_bc',
  'product.provider.attributes.insurancecard_vc':
    'overview.selectedProduct.provider.attributes.insurancecard_vc',
  'product.provider.attributes.insurancecard_wa':
    'overview.selectedProduct.provider.attributes.insurancecard_wa',
  // 'config.phoneNumber': '?',
  'userdata.user.user.user_birthdate': 'getUserInput.birthdate',
  'userdata.user.car.car_licenceplate': 'getUserInput.licensePlate',
  'userdata.carinfo.Make': 'getUserInput.carMake',
  'userdata.carinfo.Model': 'getUserInput.carModel',
  'userdata.carinfo.ConstructionYear': 'getUserInput.constructionYear',
  'userdata.carinfo.ConsumerPrice': 'getUserInput.consumerPrice',
  'userdata.carinfo.SecuritySystemClass': 'getUserInput.securitySystemClass',
};

export default propMapping;
